import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { HttpService } from "../shared/services/http.service";

import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { ActivatedRoute, Router } from "@angular/router";
import { ControllerService } from "../shared/services/controller.service";

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    standalone: false
})
export class UserComponent implements OnInit {


  users: any = [];
  dataSource: any;

  clientId = ''
  clientName = ''
  userFilter = ''
  page = 0
  size = 10
  count = 0
  loading = false


  filterDebounce: any

  displayedColumns = [];
  @ViewChild(MatSort, { static: true }) sort: MatSort = new MatSort();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;


  columnNames = [
    {
      id: 'super',
      value: "SUPER",
      rareOnly: true
    },
    {
      id: "hr",
      value: "HR",
    },
    {
      id: "email",
      value: "Email",
    },
    {
      id: "codes",
      value: "Codes"
    },
    {
      id: 'ts',
      value: 'Last Visit'
    }
  ];

  constructor(private httpService: HttpService, private router: Router, public controller: ControllerService, private route: ActivatedRoute, private cdr: ChangeDetectorRef) {

  }

  async sortData(){
    await this.fetchUsers(this.clientId, this.page, this.size)
  }

  async toggleHR( event, userId ){
    await this.httpService.postAsync("hclient/toggleHR", {userId, hr: event.checked})
    await this.fetchUsers( this.clientId, this.page, this.size )
  }


  async toggleSuper( event, userId ){
    await this.httpService.postAsync("hclient/toggleSuper", {userId, super: event.checked})
    await this.fetchUsers( this.clientId, this.page, this.size )
  }

  async onPaginateChange(event: PageEvent) {
    this.page = event.pageIndex;
    this.size = event.pageSize;


    // Fetch data for the new page
    const resp: any = await this.fetchUsers(this.clientId, this.page, this.size);
    this.cdr.detectChanges(); // Force change detection


  }

  userDetails( id ){
    this.router.navigate([`/user/${id}`])
  }

  filter( event ){

    if( this.filterDebounce ){
      window.clearTimeout( this.filterDebounce )
    }

    this.page = 0

    this.filterDebounce = window.setTimeout( async () => {
      this.userFilter = event.target.value.trim()
      await this.fetchUsers(this.clientId, this.page, this.size)
      this.dataSource.filter = this.userFilter

    }, 250 )
  }

  // ...

  skeletonRows: number[][] = [];

  generateSkeletonRows() {
    this.skeletonRows = Array(10).fill(0).map(() => {
      // Random number of bars between 5 and 8 to ensure density
      const barCount = Math.floor(Math.random() * (8 - 5 + 1)) + 5;
      const bars = [];
      for (let i = 0; i < barCount; i++) {
        // Random flex weight between 1 and 10 to give variety in width
        bars.push(Math.floor(Math.random() * 10) + 1);
      }
      return bars;
    });
  }

  async fetchUsers( clientId, page, size ){
    this.loading = false
    this.generateSkeletonRows(); // Generate new random rows on fetch
    const filter = this.userFilter

    const sort = {
      active: this.sort.active,
      direction: this.sort.direction
    }

    try {
      const resp:any = await this.httpService.postAsync("hclient/listUsers", {clientId, page, size, filter, sort})
      if( resp.success ){
        this.users = resp.data
        this.count =  resp.count
      }else{
        alert("Error loading users")
      }

      this.dataSource.data = this.users
      this.paginator.length = resp.count;
      this.paginator.pageIndex = page;
    } finally {
      this.loading = false
    }
  }

  async fetchClients( ){
    try{
      const clients = await this.httpService.postAsync("hclient/listClients", {})
      this.controller.setClients( clients )
    }catch( e ){
        this.controller.redirectToSignIn()
    }
  }

  async ngOnInit() {

    this.dataSource = new MatTableDataSource(this.users);
    this.dataSource.sort = this.sort;

    if( this.controller.getClients().length == 0 ){
      await this.fetchClients()
    }

    this.route.url.subscribe( async (url) =>{
      const clientParam = url[1].path
      const clientId = this.controller.getClientId(clientParam)

      this.clientName = this.controller.getClientName(clientId)
      this.clientId = clientId

      this.displayedColumns = this.columnNames.filter( (it) => {
        if( it.rareOnly ){
          return parseInt(this.clientId,10) === 1
        }
        return true
      }).map(x => x.id);


      if( clientParam === '_ALL_'){
        this.clientName = 'ALL'
        this.clientId = '0';
        this.displayedColumns.unshift("client")
      }

      if( !clientId) {

        console.error("no clientid")
        return
      }
      await this.fetchUsers(clientId, this.page, this.size)

    })
  }

}
